import { FETCH_ADMIN_ACCESS_USERS, CREATE_ADMIN_ACCESS } from 'actions/adminAccess';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  adminUsers: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 0,
};

const adminAccessReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ADMIN_ACCESS_USERS.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_ADMIN_ACCESS_USERS.SUCCESS: {
      return {
        ...state,
        adminUsers: payload.data?.results,
        isLoading: false,
        page: payload.data?.page,
        limit: payload.data?.limit,
        totalPages: payload.data?.totalPages,
        total: payload.data?.totalResults,
      };
    }

    case FETCH_ADMIN_ACCESS_USERS.FAIL: {
      return { ...state, isLoading: false };
    }

    case CREATE_ADMIN_ACCESS.REQUEST: {
      return { ...state, isLoading: true };
    }

    case CREATE_ADMIN_ACCESS.SUCCESS: {
      toast.success('Admin access created successfully');
      return {
        ...state,
        isLoading: false,
      };
    }

    case CREATE_ADMIN_ACCESS.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};

export default adminAccessReducer;
